import { TypeHelper } from "../TypeHelper";
import { IRuleOptions, IValidationOptions, IValidationRule, RuleName } from "./Validator";

export class IsNumberRule implements IValidationRule
{
    public rule: RuleName = 'IsNumber';
    private errorLabel: string;

    constructor(validationOptions: IValidationOptions, ruleOptions: IRuleOptions = {})
    {
        this.errorLabel = ruleOptions.errorLabel ?? validationOptions.mustBeNumberLabel ?? validationOptions.invalidFieldLabel;
    }

    public validate(value: string): string
    {
        if (TypeHelper.toNumber(value) !== undefined)
        {
            return '';
        }
        return this.errorLabel;
    }
}
